import React from 'react'
import {
  IonContent,
  IonPage,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardTitle,
  IonButton,
  IonIcon
} from '@ionic/react'
import { arrowBackOutline } from 'ionicons/icons'
import { useTranslation } from 'react-i18next'
import PageHeader from '../../components/PageHeader'
import PrivacyPolicyContent from '../../components/legal/PrivacyPolicyContent'
import PlatformService from '../../services/platform'

const PrivacyPolicy: React.FC = () => {
  const { t, i18n } = useTranslation()
  const isGerman = i18n.language === 'de'
  const isWeb = PlatformService.isWeb()

  return (
    <IonPage>
      <PageHeader title={t('legal.privacyPolicy')} />
      <IonContent className="ion-padding">
        <div className="max-w-4xl mx-auto">
          {isWeb && (
            <IonButton
              fill="clear"
              routerLink="/"
              className="mb-4 hidden md:flex"
            >
              <IonIcon icon={arrowBackOutline} slot="start" />
              {t('legal.backToHome')}
            </IonButton>
          )}

          <IonCard>
            <IonCardHeader>
              <IonCardTitle>{t('legal.privacyPolicy')}</IonCardTitle>
              <p className="text-sm text-gray-600">
                {isGerman ? 'Zuletzt aktualisiert: Juni 2025' : 'Last updated: June 2025'}
              </p>
            </IonCardHeader>
            <IonCardContent>
              <PrivacyPolicyContent />
            </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default PrivacyPolicy 